const isBrowserOutdated = (): boolean => {
  const userAgent = window.navigator.userAgent;

  return userAgent.includes('MSIE ') || userAgent.includes('Trident/');
};

export default isBrowserOutdated;
